/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { ListProjectsVideoEditorProjectsQueryResponse, ListProjectsVideoEditorProjectsQueryParams } from "../models/ListProjectsVideoEditorProjects";

export function getListProjectsVideoEditorProjectsUrl() {
  const res = { method: 'GET', url: `/video-editor/projects` as const }
  return res
}

/**
 * @summary List projects for the client scoped to a fragment; each item includes creator, published platforms, and rendered video URL when a completed render exists
 * {@link /video-editor/projects}
 */
export async function listProjectsVideoEditorProjects(params: ListProjectsVideoEditorProjectsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListProjectsVideoEditorProjectsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListProjectsVideoEditorProjectsUrl().url.toString(), params, ... requestConfig })
  return res.data
}